import { createSelector } from 'reselect';
const selectShareVideo = state => state.share_video;

export const selectVideo = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video
);
export const selectUserIsOwner = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.current_user_is_owner
);
export const selectVideoBelongsToTeam = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video_is_team_shared
);
export const selectVideoUseEmojis = createSelector(
  selectVideo,
  video => video.use_emojis
);
export const selectVideoViews = createSelector(
  selectVideo,
  video => video.views
);
export const selectUserCanEditVideo = createSelector(selectShareVideo, video =>
  Boolean(
    video.current_user_is_owner ||
      video.video_is_team_shared ||
      video.video?.collaboratePermissions.write
  )
);
